import { Component, Input } from '@angular/core';
import { Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComplementaryResourcesProgress } from 'src/app/models/career-plans';

@Component({
  selector: 'app-complementary-resource-card',
  templateUrl: './complementary-resource-card.component.html',
  styleUrls: ['./complementary-resource-card.component.scss'],
})
export class ComplementaryResourceCardComponent {
  @Input()
  resource: ComplementaryResourcesProgress;

  @Input()
  levelId: string;

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {}

  get completionLabelKey(): string {
    return this.resource.progress === 100 ? 'careerPlans.status.completed' : 'careerPlans.status.checking';
  }

  navigateToResource() {
    const params: Params = {
      limit: 24,
      offset: 0,
      order: 'fechaModifica_dt:desc',
      title: this.translate.instant('careerPlans.complementary.title', {
        hours: this.resource.hoursToComplete,
      }),
      careerPlanLevelId: this.levelId,
      showReturnButton: true,
      hideButtonsSideMenu: true,
      originPage: '/user/career-plans'
    };
    this.router.navigate(['/results'], { queryParams: params });
  }
}
